(function() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var trigger = document.getElementById('cart-drawer-trigger');
  var itemsContainer = document.getElementById('cart-drawer-items');
  var emptyState = document.getElementById('cart-drawer-empty');
  var footer = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var countEl = document.getElementById('cart-drawer-count');
  var savingsAmountEl = document.getElementById('cart-drawer-savings-amount');
  var progressEl = document.getElementById('cart-progress');
  var progressBar = document.getElementById('cart-progress-bar');
  var progressMsg = document.getElementById('cart-progress-message');

  var FREE_SHIPPING_THRESHOLD = 4000;
  var scrollY = 0;

  (function() {
    var dayName = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long' }).format(new Date());
    var msg = (dayName === 'Friday' || dayName === 'Saturday')
      ? 'Please allow up to 2 days for your order to be picked, packed and prepared for shipment.'
      : 'Please allow up to 24 hours for your order to be picked, packed and prepared for shipment.';
    document.getElementById('cart-processing-msg').textContent = msg;
  })();

  function setDrawerHeight() {
    drawer.style.height = window.innerHeight + 'px';
  }

  function openDrawer() {
    setDrawerHeight();
    fetchCartAndRender();
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  window.addEventListener('resize', function() {
    if (drawer.classList.contains('is-open')) setDrawerHeight();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateProgressBar(total) {
    var remaining = FREE_SHIPPING_THRESHOLD - total;
    var pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    progressBar.style.width = pct + '%';
    if (remaining <= 0) {
      progressEl.classList.add('cart-progress--complete');
      progressMsg.innerHTML = 'You\'ve unlocked <strong>FREE shipping!</strong>';
    } else {
      progressEl.classList.remove('cart-progress--complete');
      progressMsg.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE shipping</strong>';
    }
  }

  function fetchCartAndRender() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); });
  }

  function renderCart(cart) {
    updateProgressBar(cart.total_price);
    countEl.textContent = cart.item_count + ' item(s)';

    var pbd = window.__purityPBD || {};
    var totalSavings = cart.items.reduce(function(sum, item) {
      var data = pbd[item.product_id];
      var compareCents = 0;
      if (data) {
        var idx = data.variantIds.indexOf(item.variant_id);
        if (idx !== -1) {
          if (data.prices && data.prices[idx] != null) {
            compareCents = Math.round(parseFloat(data.prices[idx]) * 100);
          } else if (data.comparePrices && data.comparePrices[idx]) {
            compareCents = data.comparePrices[idx];
          }
        }
      } else if (item.compare_at_price) {
        compareCents = item.compare_at_price;
      }
      if (compareCents > item.final_price) {
        return sum + (compareCents - item.final_price) * item.quantity;
      }
      return sum;
    }, 0);
    savingsAmountEl.textContent = '-' + formatMoney(totalSavings);

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '';
      emptyState.style.display = 'block';
      footer.style.display = 'none';
      return;
    }

    emptyState.style.display = 'none';
    footer.style.display = 'block';
    subtotalEl.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function(item, index) {
      var variantHtml = (!item.product_has_only_default_variant && item.variant_title)
        ? '<span class="cart-drawer__variant">' + item.variant_title + '</span>'
        : '';
      var subscriptionHtml = item.selling_plan_allocation
        ? '<span class="cart-drawer__subscription">Subscription: ' + item.selling_plan_allocation.selling_plan.name + '</span>'
        : '';
      var lineDiscount = (item.original_price > item.final_price)
        ? (item.original_price - item.final_price) * item.quantity
        : 0;
      var discountBadgeHtml = lineDiscount > 0
        ? '<span class="cart-drawer__discount-badge">' + formatMoney(lineDiscount) + ' Off – Bundle Discount!</span>'
        : '';
      var lineNum = index + 1;
      html += '<div class="cart-drawer__item" data-line="' + lineNum + '">' +
        '<img src="' + item.image + '" alt="' + item.title + '" width="80" height="80" loading="lazy">' +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          variantHtml + subscriptionHtml +
          '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
          discountBadgeHtml +
        '</div>' +
        '<div class="cart-drawer__item-actions">' +
          '<div class="cart-drawer__qty">' +
            '<button class="cart-drawer__qty-btn" data-action="decrease" data-line="' + lineNum + '">&#8722;</button>' +
            '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
            '<button class="cart-drawer__qty-btn" data-action="increase" data-line="' + lineNum + '">&#43;</button>' +
          '</div>' +
          '<button class="cart-drawer__remove" data-line="' + lineNum + '" aria-label="Remove ' + item.product_title + '">&#215;</button>' +
        '</div>' +
      '</div>';
    });
    itemsContainer.innerHTML = html;
  }

  function updateQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
      updateHeaderCount(cart.item_count);
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.header__menu_count, [data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
  }

  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;

  if (trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  itemsContainer.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action], .cart-drawer__remove');
    if (!btn) return;
    var line = parseInt(btn.dataset.line);
    var action = btn.dataset.action;
    if (btn.classList.contains('cart-drawer__remove')) {
      updateQuantity(line, 0);
    } else if (action === 'increase') {
      var qtyEl = btn.closest('.cart-drawer__qty').querySelector('.cart-drawer__qty-value');
      updateQuantity(line, parseInt(qtyEl.textContent) + 1);
    } else if (action === 'decrease') {
      var qtyEl = btn.closest('.cart-drawer__qty').querySelector('.cart-drawer__qty-value');
      var current = parseInt(qtyEl.textContent);
      if (current > 1) updateQuantity(line, current - 1);
    }
  });
})();
